import { extendTheme } from "@chakra-ui/react";

const theme = extendTheme({
  colors: {
    brand: {
      50: "#e2eaf1",
      100: "#b6c9dc",
      200: "#89a7c7",
      300: "#5c85b2",
      400: "#32699d",
      500: "#092f52", // Main brand color
      600: "#072744",
      700: "#051f36",
      800: "#031728",
      900: "#010f1a",
    },
    blue: {
      500: "#2b6cb0"
    },
    reading: {
      100: "#e0324c21",
      500: "#e0324c"
    },
    practice: {
      100: "#0a9cae1f",
      500: "#0a9cae"
    },
    form: {
      100: "#20913829",
      500: "#209138"
    },
    primary: "#092f52",
    secondary: "#5c85b2",
  },
  fonts: {
    body: "Lato, sans-serif",
    heading: "Lato, sans-serif",
  },
});

export default theme;
